// Aiyavi Retreat brand assets (properly cropped, transparent PNGs in /public/brand)
export const LOGO_WHITE = "/brand/aiyavi-white.png";
export const LOGO_DARK = "/brand/aiyavi-dark.png";
